/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { ProductionChange } from "./modelProductionChange";
import { Input } from "../input/modelInput";
import { Current } from "../current/modelCurrent";

import { 
    InputMelFinal, 
    InputLogicFabrica, 
    InputLogicDestilaria, 
    InputAjustCaldoBrixDest,
    InputAjustCaldoVazaoDest,
    InputAjustCaldoBrixFab,
    OutputMelFinal,
    OutputVazaoDest,
    OutputVazaoFab,
    OutputMosto,
    OutputBrixMosto
} from "../_service/simulationManagement/fixedCurrents"
import Properties from "../_model/ModelEngineeringProperties";

class ControllerProductionChange extends ControllerModel {
  constructor() {
    super("ControllerProductionChange");
    
    this.setNewNode = (callback) => {
      let productionChange = new ProductionChange();
      productionChange.decorate(callback);
      try {
         let dest= [
          this.setInputLogicDestilaria(callback),
          this.setInputAjustCaldoVazaoDest(callback),
          this.setInputAjustCaldoBrixDest(callback),
          this.setOutputMelFinal(callback)
        ]
  
        let fab = [
          this.setInputLogicFabrica(callback),
          this.setInputAjustCaldoBrixFab(callback),

          this.setInputMelFinal(callback),
        ]

        productionChange.nodesToDest = dest.filter( n => n)
        productionChange.nodesToFab = fab.filter( n => n)
      } catch (error) {
        productionChange.kill()
      }

      this.addNode(productionChange);
    }

    this.getProperties = async (node) => {
      let n = new ProductionChange();
      await n.copyFrom(node);
      return n.data
    }

    this.getNode = (node) => {
      let n = new ProductionChange();
      n.copyFrom(node);
      return n
    }

    this.loadNode = (node, callback) => {
      let productionChange = new ProductionChange();
      productionChange.copyFrom(node);
      productionChange.decorate(callback);
      this.addNode(productionChange)
    }

    this.setInputLogicFabrica = (callback) => {
      let inputLogicFabrica = new Input();

      inputLogicFabrica.x = 0
      inputLogicFabrica.y = 50
      inputLogicFabrica.decorate(callback);

      try {
        let nodeEdited = inputLogicFabrica.clone()
        nodeEdited.dataType = "Atributos"
        nodeEdited.title = "Vazão p/ Fábrica"
        nodeEdited.attrs = [ new Properties({...InputLogicFabrica(), value: OutputVazaoFab().value, caption: "", unit: ""}) ]
        nodeEdited.expressionVisible = "cr|i_1_500|Atributos|W == 1"
  
        inputLogicFabrica.update( nodeEdited )
        this.addNode(inputLogicFabrica);
      } catch (error) {
        inputLogicFabrica.kill()
        return
      }
      return inputLogicFabrica.clone()
    }

    this.setInputLogicDestilaria =(callback) => {
      let inputLogicDestilaria = new Input();
      
      inputLogicDestilaria.x = 0
      inputLogicDestilaria.y = 100
      inputLogicDestilaria.decorate(callback);
      
      try {
        let nodeEdited = inputLogicDestilaria.clone()
        nodeEdited.dataType = "Atributos"
        nodeEdited.title = "Vazão p/ Destilaria"
        nodeEdited.attrs = [ new Properties({...InputLogicDestilaria(), value: OutputVazaoDest().value })]
        
        nodeEdited.expressionVisible = "cr|i_1_500|Atributos|W == 2"
        inputLogicDestilaria.update( nodeEdited )
        
        this.addNode(inputLogicDestilaria);
      } catch (error) {
        inputLogicDestilaria.kill()
        return
      }
      return inputLogicDestilaria.clone()
    }

    this.setInputMelFinal = (callback) => {
      let inputMelFinal = new Input();

      inputMelFinal.x = 0
      inputMelFinal.y = 150
      inputMelFinal.decorate(callback);

      try {
        let nodeEdited = inputMelFinal.clone()
        nodeEdited.dataType = "Atributos"
        nodeEdited.title = "Mel Final"
        nodeEdited.attrs = [ new Properties({...InputMelFinal(), value: OutputMelFinal().value }) ]
        nodeEdited.expressionVisible = "cr|i_1_500|Atributos|W == 1"
  
        inputMelFinal.update(nodeEdited)
        this.addNode(inputMelFinal);
        
      } catch (error) {
        inputMelFinal.kill()
        return
      }
      return inputMelFinal.clone()
    }

    this.setInputAjustCaldoBrixDest = (callback) =>{
      let inputAjustCaldoBrixDest = new Input();

      inputAjustCaldoBrixDest.x = 0
      inputAjustCaldoBrixDest.y = 200
      inputAjustCaldoBrixDest.decorate(callback);

      try {
        let nodeEdited = inputAjustCaldoBrixDest.clone()
        nodeEdited.dataType = "Operações"
        nodeEdited.title = "Brix Desejado (%)"
        nodeEdited.attrs = [ new Properties({...InputAjustCaldoBrixDest(), value:OutputBrixMosto().value }) ]
        nodeEdited.expressionVisible = "cr|i_1_500|Atributos|W == 2"
  
        inputAjustCaldoBrixDest.update(nodeEdited)
        this.addNode(inputAjustCaldoBrixDest);       
      } catch (error) {
        inputAjustCaldoBrixDest.kill()
        return
      }
      return inputAjustCaldoBrixDest.clone()
    }
    
    this.setInputAjustCaldoVazaoDest = (callback) =>{
      let inputAjustCaldoVazaoDest = new Input();

      inputAjustCaldoVazaoDest.x = 0
      inputAjustCaldoVazaoDest.y = 250
      inputAjustCaldoVazaoDest.decorate(callback);

      try {
        let nodeEdited = inputAjustCaldoVazaoDest.clone()
        nodeEdited.dataType = "Operações"
        nodeEdited.title = "Mosto Desejado m³/h"
        nodeEdited.attrs = [ new Properties({...InputAjustCaldoVazaoDest(), value: OutputMosto().value }) ]
        console.log('nodeEdited.attrs :>> ', nodeEdited.attrs);
        nodeEdited.expressionVisible = "cr|i_1_500|Atributos|W == 2"
  
        inputAjustCaldoVazaoDest.update(nodeEdited)
        this.addNode(inputAjustCaldoVazaoDest);
      } catch (error) {
        inputAjustCaldoVazaoDest.kill()
        return
      }
      return inputAjustCaldoVazaoDest.clone()
    }

    this.setInputAjustCaldoBrixFab = (callback) =>{
      let inputAjustCaldoBrixFab = new Input();

      inputAjustCaldoBrixFab.x = 0
      inputAjustCaldoBrixFab.y = 300
      inputAjustCaldoBrixFab.decorate(callback);

      try {
        let nodeEdited = inputAjustCaldoBrixFab.clone()
        nodeEdited.dataType = "Operações"
        nodeEdited.title = "Brix Desejado (%)"
        nodeEdited.attrs = [ new Properties({...InputAjustCaldoBrixFab(), value:OutputBrixMosto().value }) ]
        nodeEdited.expressionVisible = "cr|i_1_500|Atributos|W == 1"
  
        inputAjustCaldoBrixFab.update(nodeEdited)
        this.addNode(inputAjustCaldoBrixFab);
      } catch (error) {
        inputAjustCaldoBrixFab.kill()
        return
      }
      return inputAjustCaldoBrixFab.clone()
    }
    
    this.setOutputMelFinal = callback => {
      let outputMelFinal = new Current();
  
      outputMelFinal.x = 0
      outputMelFinal.y = 350
      outputMelFinal.decorate(callback);

      try {
        let nodeEdited = outputMelFinal.clone()
        nodeEdited.dataType = "Correntes"
        nodeEdited.title = "Mel Final"
        nodeEdited.attrs = [ new Properties({...OutputMelFinal(), caption: ""}) ]
        nodeEdited.expressionVisible = "cr|i_1_500|Atributos|W == 2"
    
        outputMelFinal.update(nodeEdited)
        this.addNode(outputMelFinal);
      } catch (error) {
        outputMelFinal.kill()
        return
      }
        return outputMelFinal.clone()
    }
  } 
}

export { ControllerProductionChange };
